export default __webpack_public_path__ + "static/media/026-smoke-detector.449edad6.png";